import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchUsersModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchUsersModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchUsersModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchUsersModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchUsersModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
